import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import membershipStore from '../../../stores/membershipStore';
import { T } from '../../../stores/textStore';
import { TRIAL_PROMO_CODE } from '../constants'


export default class extends Component {
	renderOptions() {
		const { membership } = this.props;
		if (membership.slug === 'free') {
			return null;
		}				
		if (membershipStore.getPendingUserSubscription()) {
			return null;
		}		
		if (membership.retired) {
			return null;
		}
		const currentMembership = membershipStore.getCurrentMembership();		
		if (currentMembership.level === membership.level) {
			return null;
		}
		if (currentMembership.level < membership.level) {
			if (membershipStore.isTrialMode() && membership.slug === 'onehouse-community' &&
					membershipStore.promoCode.get() === TRIAL_PROMO_CODE) {
				return (
					<Link 
							to={`/change/${membership.slug}`} 
							className="btn btn-block btn-lg tkc-btn-red rounded-0 mb-3"
					>						
						{T('Try 14 Days Free')}
					</Link>
				);				
			}
			return (
				<Link 
						to={`/change/${membership.slug}`} 
						className="btn btn-block btn-lg tkc-btn-red rounded-0 mb-3">
					{T('Upgrade')}
				</Link>
			);	
			/*		
			return (
				<Link to={`/change/${membership.slug}`} className="btn tkc-btn-red mb-3">
					{T('Upgrade to')} {membership.name}
				</Link>
			);
			*/
		}
		if (currentMembership.level > membership.level)	{
			return (
				<Link to={`/change/${membership.slug}`} className="btn btn-secondary">
					{T('Downgrade to')} {membership.name}
				</Link>
			);
		}
	}

	render() {
		const { membership } = this.props;
		return (			
			<div className="card text-center mb-5">
				<div className="card-header bg-white">
					<h6 className="text-uppercase">{membership.name}</h6>
				</div>
				<div className="card-body">					
					{membership.slug === 'free' &&
						<h5>${membership.annual_price}</h5>
					}
					{membership.slug !== 'free' &&
						<span>
							<h5>
								{/*USD ${membership.annual_price/12}<br />*/}
								{membershipStore.getAnnualPrice(membership).display}<br />
								<small>{T('per month billed annually')}</small>
							</h5>
							<hr className="mx-5" />
							<p>															
								{T('Or')} {membershipStore.getMonthlyPrice(membership).display} {T('month-to-month')}
							</p>
							{!this.props.noOptions && this.renderOptions()}
                            {membership.features_as_list.map(feature =>
                                <p className="text-left" key={feature}>
                                    <span className="ic-check tkc-text-red"></span>
                                    {feature}
                                </p>
							)}	
							{membership.disclaimers_as_list.map(disclaimer =>
								<p className="text-left small" key={disclaimer}>                        
									{disclaimer}
								</p>
							)}  													
						</span>
					}
				</div>
			</div>
		);		
	}
}




// WEBPACK FOOTER //
// ./src/views/membership/components/MembershipListing.js